import { replaceCdnAddress } from "@/utils/common";
export default {
  data() {
    return {
      typeMaper: {
        PRODUCT: 1,
        ENGINEERING_CASE: 2,
        TECHNOLOGY: 3,
        NEWS: 4
      }
    };
  },
  computed: {
    localeColumns() {
      return this.$store.getters.localeColumns;
    },
    predefineColors() {
      return this.$store.getters.predefineColors;
    }
  },
  methods: {
    buildFormItem() {
      return {
        title: { ...this.localeColumns },
        utc_post: new Date().getTime(),
        description: { ...this.localeColumns },
        description_image_url: "",
        content: { ...this.localeColumns },
        reference_url: "",
        poster_image_url: "",
        poster_slogan: { ...this.localeColumns },
        tag_ids: [],
        vgc_article_id: null,
        seq: 1
      };
    },
    buildFormByVgcItem(data) {
      let formData = this.buildFormItem();
      formData.title = { cn: data.title, en: data.title };
      formData.utc_post = data.postMillisecond;
      formData.description = {
        cn: data.descriptionText,
        en: data.descriptionText,
      };
      formData.description_image_url = replaceCdnAddress(
        data.descriptionImageUrl
      );
      formData.content = { cn: data.content, en: data.content };
      formData.reference_url = data.referenceUrl;
      formData.poster_image_url = replaceCdnAddress(data.posterImageUrl);
      formData.poster_slogan = {
        cn: data.posterSlogan,
        en: data.posterSlogan,
      };
      formData.tag_ids = [this.typeMaper[data.typeId]];
      formData.vgc_article_id = data.id;
      formData.seq = 1;
      return formData;
    }
  }
};
